import { call, put, takeLatest } from "redux-saga/effects";
import {
  editFacultyStart,
  editFacultyFailure,
  editFacultySuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpEditFaculty } from "../../../services/faculty";
import { successNotifier } from "../../../utils/helpers";

export function* editFaculty({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpEditFaculty, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editFacultySuccess());
    successNotifier("faculty edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editFacultyFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onEditFaculty() {
  yield takeLatest(editFacultyStart.type, editFaculty);
}
